import type { ApolloClient, NormalizedCacheObject } from "@apollo/client";
import { createContext } from "react";

interface ServerData {
  url: string;
  origin: string;
  deviceType?: string;
  userAgent?: string;
  apolloClient?: ApolloClient<NormalizedCacheObject>;
  cookie?: string;
  isReactNativeWebView?: boolean;
}

const DefaultServer: ServerData = {
  url: "",
  origin: "",
  deviceType: "desktop",
  userAgent: "",
  cookie: undefined,
  isReactNativeWebView: false,
};

const ServerContext = createContext<ServerData>(DefaultServer);

export type { ServerData };
export { ServerContext, DefaultServer };
